import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';
import JavaScriptSvg from 'devicon/icons/javascript/javascript-plain.svg';

export const JavaScript = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="lang-javascript" className={cx('sdkIcon', className)} size={size} {...props}>
    <JavaScriptSvg />
  </LegacyIcon>
);
